import { render, staticRenderFns } from "./DefiTokenList.vue?vue&type=template&id=3789df58&"
import script from "./DefiTokenList.vue?vue&type=script&lang=js&"
export * from "./DefiTokenList.vue?vue&type=script&lang=js&"
import style0 from "./DefiTokenList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports